import styles from "@styles/Loader.module.css";
import { DSSmith } from "@components/Icons";
import { createContext, Dispatch, PropsWithChildren, SetStateAction, useEffect, useState } from "react";

export type LoadingContextProps = {
    loaded: boolean;
    setLoaded: Dispatch<SetStateAction<boolean>>;
}
export const loadingContext: LoadingContextProps = {
    loaded: false,
    setLoaded: undefined!
}
export const LoadingContext = createContext(loadingContext);

let interval: NodeJS.Timer;
export function Loader({ children }: PropsWithChildren) {
    const [loaded, setLoaded] = useState(false);

    const [progress, setProgress] = useState(2);

    useEffect(() => {
        interval = setInterval(() => {
            setProgress(p => (p + 1) % 3);
        }, 300);
        return () => clearInterval(interval);
    }, [setProgress]);

    useEffect(() => {
        if (loaded) clearInterval(interval);
    }, [loaded]);

    let ellipsis = "";
    for (let i = 0; i <= progress; ++i) ellipsis += ".";

    return (
        <LoadingContext.Provider value={{ loaded, setLoaded }}>
            {children}
            <div className={styles.root} style={{ opacity: loaded ? 0 : 1 }}>
                <div className={styles.logo}>
                    <DSSmith />
                </div>
                <div className={styles.text}>
                    <span data-ellipsis={ellipsis}>Loading</span>
                </div>
            </div>
        </LoadingContext.Provider>
    );
}